export function getView(value) {
  return Array.isArray(value) && value.length !== 0 && value.length !== 4
}
